<template>
  <CommonLayout header="floristHeader" footer="floristFooter">
    <div class="p-5" style="min-height: 400px">
      <div class="text-center m-5" id="msgBox">
        <template v-for="(msg, index) in mainMsg" :key="index">
          <p class="h5">{{msg}}</p>
        </template>
        <BSpinner v-show="spinnerShow" class="mt-5"></BSpinner>
      </div>
    </div>
    <CommonModal ref="commonModal" />
    <div class="p-2">
      <p class="mb-0 text-light h2" id="logo" style="cursor:default;user-select:none" v-if="tabErrorShow">
        <a href="javascript:void(0)" style="font-size: 11px; color:red" @click="clickTabIni">
          {{ this.consts.messages.clearMultipleStart }}
          <!--※他のタブで打合せ操作を行っていないのに、「複数のタブで打合せ操作を行うことはできない」旨のエラーが発生している場合-->
        </a>
        <CommonModal ref="commonModalForTabIni" @confirmOk="deleteTabInfo" />
      </p>
    </div>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import LoginModel from '@/models/LoginModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import fstore from '@/store/florist-store'
import CommonLogModel from '@/models/CommonLogModel'
import ProdInstStartModel from '@/models/ProdInstStartModel'
import SearchFacilityInfoModel from '@/models/SearchFacilityInfoModel'
import { BSpinner } from 'bootstrap-vue-next'

export default {
  name: 'FloristMeetingIndex',
  components: { CommonLayout, CommonModal, BSpinner },
  data () {
    return {
      spinnerShow: true,
      mainMsg: ['ログイン中です。', 'しばらくお待ち下さい'],
      signalingData: [],
      tabErrorShow: false
    }
  },
  computed: {
    getSignalingData () {
      return fstore.getters.signalingReceiveData
    }
  },
  created () {
    localStorage.removeItem('projectTypes')
    localStorage.removeItem('suggestionData')
  },
  mounted () {
    this.auth()
  },
  unmounted () {
    if (MeetingStartModel.getStore()) {
      MeetingStartModel.removeStore()
    }
  },
  methods: {
    async auth () {
      try {
        const [projectNumber, password] = this.getProjectNumberAndPassword()
        const afterMTG = this.getAfterMTG()
        const prodInst = this.getProdInst()
        const referenceFlag = this.getReferenceFlag()
        const userName = this.getUserName()

        await this.login(projectNumber, password, afterMTG, prodInst)

        const loginStatus = { beforeLogin: '1', afterMTG, prodInst, referenceFlag, userName}
        localStorage.setItem('loginStatus', JSON.stringify(loginStatus))

        let targetPath = '/florist/meeting/agenda'

        if (prodInst !== '1') {
          const meetingStartModel = await this.meetingStart()

          sessionStorage.meeting = JSON.stringify(meetingStartModel.meeting)
          sessionStorage.attendee = JSON.stringify(meetingStartModel.attendee)

          const urlUpdatTime = Date.parse(meetingStartModel.meetingURL.updatedDateTime + '+09:00')

          if (Date.now() - urlUpdatTime < this.config.UrlTransitionTimeLimit) {
            const meetingurl = meetingStartModel.meetingURL.currentURLPath
            if (meetingurl !== '') {
              targetPath = '/florist/' + meetingurl

              fstore.commit('setIsOperationPossible', meetingStartModel.meetingURL.operatingPrivilege === '0')
              fstore.commit('setCustomerDisplayFlag', meetingStartModel.meetingURL.customerDisplayFlag === '1')

              const suggestionData = meetingStartModel.meetingURL.suggestionData
              if (suggestionData) localStorage.setItem('suggestionData', suggestionData)
            }
          }

          const facilityData = await SearchFacilityInfoModel.getApi(
            this.$refs.commonModal,
            projectNumber,
            () => {}
          )

          if ('records' in facilityData && facilityData.records.length > 0 &&
              facilityData.records[0]['スペック提案時の初期表示'].value.length > 0) {
            localStorage.setItem('specFirstDisplay', true)
          } else {
            localStorage.setItem('specFirstDisplay', false)
          }

          if ('records' in facilityData && facilityData.records.length > 0 &&
              facilityData.records[0]['商品提案時の初期表示'].value.length > 0) {
            localStorage.setItem('productFirstDisplay', true)
          } else {
            localStorage.setItem('productFirstDisplay', false)
          }

          if ('records' in facilityData && facilityData['records'].length > 0 && facilityData['records'][0]['商品提案時の初期表示_注力商品']['value'].length > 0) {
            localStorage.setItem('focusProductFirstDisplay', true)
          } else {
            localStorage.setItem('focusProductFirstDisplay', false)
          }

          CommonLogModel.apiSetStore(this.$refs.commonModal,{ timestampMs: Date.now(), current_path: this.$route.path, reloadPath: targetPath },() => {})
        } else {
          await this.prodInstStart()
          // 制作指示画面の場合はhearing画面に遷移する
          targetPath = '/florist/meeting/hearing'
        }
        // ログイン完了したため、ログイン前フラグを'0'に更新
        loginStatus.beforeLogin = '0'
        localStorage.setItem('loginStatus', JSON.stringify(loginStatus))

        this.$router.push(targetPath)
      } catch (err) {
        console.log(err)
        CommonLogModel.apiSetStore(
          this.$refs.commonModal,
          { timestampMs: Date.now(), errorMessage: err },
          () => {}
        )
      }
    },
    authStop () {
      this.mainMsg = null
      this.mainMsg = Object.assign([], this.mainMsg, ['最初からやりなおしてください'])
      this.spinnerShow = false
    },
    getProjectNumberAndPassword () {
      if (!this.$route.query.projectNumber) {
        this.$refs.commonModal.msgBoxOk('予期せぬエラーが発生しました')
        this.authStop()
        throw new Error('auth error')
      }
      return [this.$route.query.projectNumber, this.$route.query.password]
    },
    async login (projectNumber, password, afterMTG, prodInst) {
      if (localStorage.getItem('tabInfo')) {
        this.$refs.commonModal.msgBoxOk(this.consts.errorMsg.multipleStart)
        this.authStop()
        this.tabErrorShow = true
        throw new Error(this.consts.errorMsg.multipleStart)
      }

      const reqData = {
        projectNumber,
        password,
        afterMTG,
        prodInst,
        attendeeType: this.consts.attendeeType.florist
      }

      const loginModel = await LoginModel.apiSetStore(
        this.$refs.commonModal,
        reqData,
        null,
        (err) => {
          let errorMsg = 'エラーが発生しました'
          if (err?.response?.data?.message) errorMsg = err.response.data.message
          else if (err?.message) errorMsg = err.message

          this.$refs.commonModal.msgBoxOk(errorMsg)
          this.authStop()
          throw new Error('API error.')
        }
      )

      localStorage.isOnlineMeeting = loginModel?.isOnlineMeeting

      if (!loginModel) {
        this.$refs.commonModal.msgBoxOk('ログイン処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      } else if (loginModel.message) {
        this.$refs.commonModal.msgBoxOk(loginModel.message)
        this.authStop()
        throw new Error('API error.')
      }
    },
    async meetingStart () {
      const params = { oneTimePassword: '', attendeeType: this.consts.attendeeType.florist }

      const meetingStartModel = await MeetingStartModel.apiSetStore(
        this.$refs.commonModal,
        params,
        null,
        () => {
          this.authStop()
          throw new Error('API error.')
        }
      )

      CommonLogModel.apiSetStore(
        this.$refs.commonModal,
        { timestampMs: Date.now(), current_path: this.$route.path, comment: 'ミーティングスタート' },
        () => {}
      )

      if (!meetingStartModel) {
        this.$refs.commonModal.msgBoxOk('通話開始処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      } else if (meetingStartModel.message) {
        this.$refs.commonModal.msgBoxOk(meetingStartModel.message)
        this.authStop()
        throw new Error('API error.')
      }

      return meetingStartModel
    },
    async prodInstStart () {
      const params = { attendeeType: this.consts.attendeeType.florist }

      const prodInstStartModel = await ProdInstStartModel.apiSetStore(
        this.$refs.commonModal,
        params,
        null,
        () => {
          this.authStop()
          throw new Error('API error.')
        }
      )

      CommonLogModel.apiSetStore(
        this.$refs.commonModal,
        { timestampMs: Date.now(), current_path: this.$route.path, comment: '制作指示スタート' },
        () => {}
      )

      if (!prodInstStartModel) {
        this.$refs.commonModal.msgBoxOk('制作指示開始処理でエラーが発生しました')
        this.authStop()
        throw new Error('API error.')
      } else if (prodInstStartModel.message) {
        this.$refs.commonModal.msgBoxOk(prodInstStartModel.message)
        this.authStop()
        throw new Error('API error.')
      }

      return prodInstStartModel
    },
    getAfterMTG () { return this.$route.query.afterMTG === '1' ? '1' : '0' },
    getProdInst () { return this.$route.query.prodInst === '1' ? '1' : '0' },
    getReferenceFlag () { return this.$route.query.referenceFlag === '1' ? '1' : '0' },
    getUserName () { return this.$route.query.userName ? this.$route.query.userName : '' },
    clickTabIni () {
      this.$refs.commonModalForTabIni.msgBoxConfirm(this.consts.messages.confirmClear)
    },
    deleteTabInfo () {
      localStorage.removeItem('tabInfo')
    }
  }
}
</script>
